import { takeLatest, put, call } from 'redux-saga/effects';

import { filterUsuarioProdutor } from '../service';
import {
  NEW_FILTER_USUARIO_PRODUTOR,
  NEW_FILTER_USUARIO_PRODUTOR_PENDING,
  NEW_FILTER_USUARIO_PRODUTOR_SUCCESS,
  NEW_FILTER_USUARIO_PRODUTOR_FAILURE,
} from '../actionTypes';
import {
  CONST_FILTER_USUARIO_PRODUTOR,
  CONST_ROWS_PER_PAGE,
} from '@commons/consts';

function* sagaNewFilterUsuarioProdutor(action) {
  try {
    yield put({ type: NEW_FILTER_USUARIO_PRODUTOR_PENDING });

    let where = '';
    let filterSaved =
      sessionStorage.getItem(CONST_FILTER_USUARIO_PRODUTOR) !== null
        ? JSON.parse(sessionStorage.getItem(CONST_FILTER_USUARIO_PRODUTOR))
        : null;

    let newFilter = {
      status: '',
      userCode: '',
      name: '',
      email: '',
      whatsApp: '',
      perfil: '',
      rows: filterSaved?.rows || CONST_ROWS_PER_PAGE,
      page: filterSaved?.page || 0,
      where: '',
    };

    if (filterSaved === null || filterSaved === undefined) {
      newFilter = {
        ...newFilter,
        where: where,
      };
    } else {
      if (action.newFilter) {
        newFilter.page = 0;

        if (
          action.args.status !== null && action.args.status !== undefined && action.args.status !== ''
        ) {
          const ativoValue = action.args.status === 'S' ? 'true' : 'false';
          where = where + '&active=' + ativoValue;
        }

        if (
          action.args.userCode !== null && action.args.userCode !== undefined && action.args.userCode.trim() !== ''
        ) {
          where = where + '&userCode=' + action.args.userCode;
        }

        if (
          action.args.name !== null && action.args.name !== undefined && action.args.name.trim() !== ''
        ) {
          where = where + '&name=' + encodeURIComponent(action.args.name.trim());
        }

        if (
          action.args.email !== null && action.args.email !== undefined && action.args.email.trim() !== ''
        ) {
          where = where + '&email=' + encodeURIComponent(action.args.email.trim());
        }

        if (
          action.args.whatsApp !== null && action.args.whatsApp !== undefined && action.args.whatsApp.trim() !== ''
        ) {
          where = where + '&whatsApp=' + action.args.whatsApp;
        }

        if (
          action.args.perfil !== null && action.args.perfil !== undefined && action.args.perfil.trim() !== ''
        ) {
          where = where + '&perfil=' + action.args.perfil;
        }

        newFilter = {
          ...newFilter,
          ...action.args,
          where: where,
        };
      } else {
        if (
          filterSaved.status !== null && filterSaved.status !== undefined && filterSaved.status !== ''
        ) {
          const ativoValue = filterSaved.status === 'S' ? 'true' : 'false';
          where = where + '&active=' + ativoValue;
        }

        if (
          filterSaved.userCode !== null && filterSaved.userCode !== undefined && filterSaved.userCode.trim() !== ''
        ) {
          where = where + '&userCode=' + filterSaved.userCode;
        }

        if (
          filterSaved.name !== null && filterSaved.name !== undefined && filterSaved.name.trim() !== ''
        ) {
          where = where + '&name=' + encodeURIComponent(filterSaved.name.trim());
        }

        if (
          filterSaved.email !== null && filterSaved.email !== undefined && filterSaved.email.trim() !== ''
        ) {
          where = where + '&email=' + encodeURIComponent(filterSaved.email.trim());
        }

        if (
          filterSaved.whatsApp !== null && filterSaved.whatsApp !== undefined && filterSaved.whatsApp.trim() !== ''
        ) {
          where = where + '&whatsApp=' + filterSaved.whatsApp;
        }

        if (
          filterSaved.perfil !== null && filterSaved.perfil !== undefined && filterSaved.perfil.trim() !== ''
        ) {
          where = where + '&perfil=' + encodeURIComponent(filterSaved.perfil.trim());
        }

        newFilter = {
          ...filterSaved,
          where: where,
        };
      }
    }

    const list = yield call(
      filterUsuarioProdutor,
      newFilter.where,
      newFilter.page,
      newFilter.rows,
    );

    sessionStorage.setItem(
      CONST_FILTER_USUARIO_PRODUTOR,
      JSON.stringify(newFilter),
    );

    yield put({
      type: NEW_FILTER_USUARIO_PRODUTOR_SUCCESS,
      list: list,
      filter: newFilter,
    });
  } catch (_) {
    yield put({ type: NEW_FILTER_USUARIO_PRODUTOR_FAILURE });
  }
}

export default function* watchNewFilterUsuarioProdutor() {
  yield takeLatest(NEW_FILTER_USUARIO_PRODUTOR, sagaNewFilterUsuarioProdutor);
}
